<template>
  <div class="_make-article">
    
    <header class="ArticleMainHeader">
      <h1 class="ArticleMainTitle">การยืนยันตัวตน</h1>
    </header>
     <div class="MarkdownContent hidden-md-and-up">
      <p class="preindent">การยืนยันตัวตนสำหรับการใช้ API กับระบบของ One Chat จะต้องส่งการยืนยันตัวตน (Authorization) มาในส่วนของ Header ทุกครั้ง โดยรายละเอียดมีดังนี้</p>
  <table id="ParametersTablemo" style="margin-top: 2vh;">
  <tr>
    <th>คีย์ (Key)</th>
    <th>ประเภท (Type)</th>
    <th>คำอธิบาย (Description)</th>
  </tr>
  <tr>
    <td>Authorization</td>
    <td>String</td>
    <td>หลังเข้าสู่ระบบและกดเปิดใช้งาน Bot API สามารถตรวจสอบและเปิดใช้งาน ได้ผ่านทางแถบข้อมูล API</td>
  </tr>
</table>


    </div>

    <div class="MarkdownContent hidden-sm-and-down">
      <p class="preindent">การยืนยันตัวตนสำหรับการใช้ API กับระบบของ One Chat จะต้องส่งการยืนยันตัวตน (Authorization) มาในส่วนของ Header ทุกครั้ง โดยรายละเอียดมีดังนี้</p>
  <table id="ParametersTable" style="margin-top: 2vh;">
  <tr>
    <th>คีย์ (Key)</th>
    <th>ประเภท (Type)</th>
    <th>คำอธิบาย (Description)</th>
  </tr>
  <tr>
    <td>Authorization</td>
    <td>String</td>
    <td>หลังเข้าสู่ระบบและกดเปิดใช้งาน Bot API สามารถตรวจสอบและเปิดใช้งาน ได้ผ่านทางแถบข้อมูล API</td>
  </tr>
</table>


    </div>
  </div>
</section>

</div>

      </div>
  </div>
</template>

<script>
import Navbar from '@/components/home/Navbar'
export default {
  components: {
    Navbar
  },
  data: () => ({
    // items: [
    //   {src: '/static/image/ios_photo/ios_friend.png'},
    //   {src: '/static/image/ios_photo/ios_login.png'}
    // ]
  })
}
</script>

<style type="text/css" scoped>
.preindent {
  text-indent: 2em;
}
._make-article {
    line-height: 1.5em;
    width: 90vw;
}
.ArticleMainTitle {
    margin-top: 0;
    font-size: 2.25rem;
    line-height: 1em;
}
._make-article h1, ._make-article h2, ._make-article h3, ._make-article h4, ._make-article h5, ._make-article h6 {
    margin-top: 32px;
    margin-bottom: 24px;
}
.EndpointParametersTable {
      width: 100%;
    /*max-width: 100%;
    margin-bottom: 16px;
    border-collapse: collapse;
        display: table;
    /*border-collapse: separate;*/
    border-spacing: 2px !important;
    border-color: grey !important;
}
#ParametersTable {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 70vw;
}

#ParametersTable td, #ParametersTable th {
    border: 1px solid #ddd;
    padding: 8px;
}

#ParametersTable tr:nth-child(even){background-color: #f2f2f2;}

#ParametersTable tr:hover {background-color: #ddd;}

#ParametersTable th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}



#ParametersTablemo {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 100%;
}

#ParametersTablemo td, #ParametersTablemo th {
    border: 1px solid #ddd;
    padding: 8px;
}

#ParametersTablemo tr:nth-child(even){background-color: #f2f2f2;}

#ParametersTablemo tr:hover {background-color: #ddd;}

#ParametersTablemo th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/home/api/authorization.vue